export const heading = "Orders Written this month";
export const completeListLink = "quadreport2";
